import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

const EXAMPLES = [
  "2BHK under ₹25k in Gurgaon",
  "3BHK villa to buy in Jaipur",
  "Furnished 1BHK for a bachelor in Bengaluru",
  "Family home to rent in Chennai under 30k",
];

/**
 * Unobtrusive entry point for the AI Search Assistant. Lives on the homepage
 * hero and atop /properties. On submit it routes to the dedicated /assistant
 * surface — keeping these pages calm and uncluttered.
 */
export default function AiSearchBar({ variant = "hero", showExamples = true }) {
  const nav = useNavigate();
  const [value, setValue] = useState("");

  const go = (text) => {
    const q = (text ?? value).trim();
    if (!q) return;
    nav(`/assistant?q=${encodeURIComponent(q)}`);
  };

  const onDark = variant === "hero";

  return (
    <div className="w-full" data-testid="ai-search-bar">
      <form
        onSubmit={(e) => { e.preventDefault(); go(); }}
        className={`flex items-center gap-2 rounded-full pl-4 pr-2 py-2 border transition-shadow ${
          onDark
            ? "bg-white/95 border-white/40 shadow-[0_12px_40px_-12px_rgba(0,0,0,0.45)]"
            : "bg-white border-brand-subtle shadow-sm"
        }`}
      >
        <Sparkles size={18} className="text-[#C9A24A] shrink-0" />
        <input
          data-testid="ai-search-bar-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Tell me what you want — “2BHK under ₹25k near a metro in Gurgaon”"
          className="flex-1 bg-transparent outline-none text-sm md:text-base text-gray-900 placeholder:text-gray-400 min-w-0"
        />
        <button
          type="submit"
          data-testid="ai-search-bar-submit"
          className="shrink-0 inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold text-white bg-[#7A1E2A] hover:bg-[#661620] transition-colors"
        >
          Ask AI <ArrowRight size={15} />
        </button>
      </form>

      <div className="mt-3 flex flex-wrap gap-2">
        {showExamples && EXAMPLES.map((ex) => (
          <button
            key={ex}
            type="button"
            onClick={() => go(ex)}
            data-testid="ai-search-example-chip"
            className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${
              onDark
                ? "border-white/40 text-white/90 hover:bg-white/15"
                : "border-brand-subtle text-gray-600 hover:border-[#C9A24A] hover:text-[#7A1E2A]"
            }`}
          >
            {ex}
          </button>
        ))}
      </div>
    </div>
  );
}
